import * as React from 'react';
import { cloneDeep } from 'lodash';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { NiSelect } from '@component/index';
import {
  DataQuery,
  ValueSuggestionData,
  ParameterConfig,
  ParameterMapConfig,
  Attribute,
  ActionChannel,
  ListAction,
  FrameItem
} from '@interface/index';
import { USER_CHANNEL_NAME_MAP } from '@config/index';
import { ResponseComp } from './response';
import { dataQueryToParameter, attributeToParameter } from '@lib/quick-func';
import { NiRadio, NiTabs } from '@component/ant-component';
import { localizedString } from '@locale/index';

export type ModalUpdateFn<H> = (
  next: { [T in keyof ValueSuggestionData]?: ValueSuggestionData[T] }
) => void;

export const CompGroup = ({
  title,
  helpString,
  comp
}: {
  title: string;
  helpString?: string;
  comp: JSX.Element;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        margin: '0 0 16px 0'
      }}
    >
      <span style={{ flex: '0 120px', margin: '4px 0 0 0' }}>
        {title} {!!helpString ? <QuestionCircleOutlined /> : ''}
      </span>
      <div style={{ flex: '1' }}>{comp}</div>
    </div>
  );
};

export const UseResponses = ({
  frame,
  data,
  selectedParameters,
  availableChannels,
  onChange,
  dataQueries,
  forSlot,
  disabled,
  style
}: {
  frame: FrameItem;
  selectedParameters: Attribute[];
  availableChannels: string[];
  data: ValueSuggestionData;
  dataQueries: DataQuery[];
  forSlot?: Attribute;
  onChange: ModalUpdateFn<'responses'>;
  disabled?: boolean;
  style?: React.CSSProperties;
}) => {

  return <NiTabs
    className="modal-tab"
    key={`response-tab-${data.id}`}
    style={style}
  >
    {
      availableChannels.map((channelTag: string) => {

        const index = data.channels.findIndex((item: ActionChannel) =>
          item.tag === channelTag);

        if (index === -1) {
          return '';
        }

        const channel = data.channels[index];
        return <NiTabs.TabPane
          tab={USER_CHANNEL_NAME_MAP[channelTag] || channelTag}
          key={channelTag}
        >
          <ResponseComp
            inModal
            disabled={disabled}
            suggestion={data}
            data={{ responseSequence: (channel.actions as ListAction[]) }}
            bodyItTypeId={forSlot && forSlot.proto && forSlot.proto.id || frame.id}
            channel={channelTag}
            selectedParameters={selectedParameters}
            options={[...selectedParameters, ...dataQueries.map(dataQueryToParameter)]}
            onUpdate={(actions: any) => {
              channel.actions = actions;
              data.channels[index] = channel;
              onChange(data);
            }}
          />
        </NiTabs.TabPane>;
      })
    }
  </NiTabs>;
};
